import React from 'react'

import Link from 'components/base/Link'
import Paragraph from 'components/base/Paragraph'

import {
  Wrap,
  GroupItem,
  LocationTitle,
} from './styles'

const LocationsGroup: React.FC = (): React.ReactElement => (
  <Wrap>
    <GroupItem>
      <LocationTitle>
        <Link to='/locations/storefronts/beaverton'>Beaverton, OR</Link>
      </LocationTitle>
      <Paragraph>11835 NW Cedar Falls Dr., Suite 115</Paragraph>
    </GroupItem>
    <GroupItem>
      <LocationTitle>
        <Link to='/locations/storefronts/eugene'>Eugene, OR</Link>
      </LocationTitle>
      <Paragraph>440 Coburg Rd Suite 200</Paragraph>
    </GroupItem>
    <GroupItem>
      <LocationTitle>
        <Link to='/locations/storefronts/grants-pass'>Grants Pass, OR</Link>
      </LocationTitle>
      <Paragraph>1221 NE 7th Street</Paragraph>
    </GroupItem>
    <GroupItem>
      <LocationTitle>
        <Link to='/locations/storefronts/las-vegas'>Las Vegas, NV</Link>
      </LocationTitle>
      <Paragraph>3572 St. Rose Parkway Suite 100
      </Paragraph>
    </GroupItem>
    <GroupItem>
      <LocationTitle>
        <Link to='/locations/storefronts/medford'>Medford, OR</Link>
      </LocationTitle>
      <Paragraph>151 Rossanley Drive, Suite 105</Paragraph>
    </GroupItem>
  </Wrap>
)

export default LocationsGroup
